import React from 'react'
import p404 from 'src/assets/unAuthorized/404.svg'
import rightPlug from 'src/assets/unAuthorized/Group717.svg'
import leftPlug from 'src/assets/unAuthorized/Group718.svg'
import notText from 'src/assets/unAuthorized/PageNotFound.svg'
import { useKeycloak } from '@react-keycloak/web'
import { HOME } from 'src/utils/constants/Home'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'

const UnAuthorized = () => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  return (
    <div className={classes.unAuthorizedContainer}>
      <div className={classes.subContainer}>
        <img src={rightPlug} width={'40%'} alt={'rightPlug'} />
        <img src={p404} width={'15%'} padding={'0px 50px'} alt={'p404'} />
        <img src={leftPlug} width={'37%'} alt={'leftPlug'} />
        <img src={notText} className={classes.notxtImg} alt={'notText'} />
        <div className={classes.textContainer}>
          <span className={classes.textContent}>
            <p>{HOME?.SEEMS_LIKE_YOU_LANDED}</p>
            <p>
              You cannot log in as a Personal. Try logging in Corporate account.
            </p>
            <span className={classes.redirectContainer}>
              <a href='/corporate/dashboard' className={classes.redirectLink}>
                Click here{' '}
              </a>
              to login to Corporate Account or
              <span
                className={classes.logoutButton}
                onClick={() => {
                  sessionStorage.clear()
                  keycloak.logout()
                }}
              >
                {HOME?.LOGOUT}
              </span>
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}

export default UnAuthorized

const useStyles = makeStyles({
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: 'fit-content',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '50px',
    color: COLORS.MEDIUM_BLUE03,
    alignItems: 'center',
  },
  notxtImg: {
    width: '15%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '32px',
  },
  subContainer: { position: 'absolute', top: '25%' },
  unAuthorizedContainer: {
    backgroundColor: 'white',
    width: '100vw',
    height: '100vh',
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '10px',
  },
  logoutButton: {
    textTransform: 'unset',
    backgroundColor: '#B92250',
    color: 'white',
    fontSize: '16px',
    padding: '10px 20px 10px 20px!important',
    borderRadius: '50px',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
  },
  redirectLink: {
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  redirectContainer: {
    color: '#000',
    marginTop: '10px',
  },
})
